<style scoped>
  .attachment{
    margin-right: 5px;
    margin-bottom: 5px;
  }
</style>
<template>
  <div class="wrapper text-left">
    <v-chip
      v-for="file in files"
      :key="file.id"
      class="attachment"
      close
      color="blue"
      small
      outlined
      @click:close="confirmDeleteAttachment(file)"
    >
      {{ file.name }}
    </v-chip>
  </div>
</template>
<script>
  export default {
    props: {
      files: {
        type: Array,
        default() {
          return [];
        }
      },
      model_type: {
        type: String,
        required: true
      },
      model_id: {
        type: Number
      }
    },
    methods: {
      confirmDeleteAttachment(file) {
        if (!this.model_id) {
          this.$util.removeArrayItem(this.files, file);
          return;
        }
        this.$Modal.confirm({
          title: '删除确认',
          content: `你确定要删除 ${file.name} 吗?`,
          onOk:() => {
            this.$util.ajax.post(this.$util.api.delete_model_file, {
              bfile_id: file.id,
              link_model_type: this.model_type,
              link_model_id: this.model_id
            }).then((response) => {
              return response.data;
            }).then((res) => {
              if (res.code === 1) {
                this.$util.removeArrayItem(this.files, file);
                this.$Message.success('删除成功!');
              } else {
                this.$Modal.error({title: '提示', content: res.msg});
              }
            }).catch((e) => {
              this.$Modal.error({title: '提示', content: e.message});
            });
          }
        });
      },
    }
  }
</script>
